import { render, staticRenderFns } from "./Maintenance.vue?vue&type=template&id=28cbd2b7&scoped=true"
import script from "./Maintenance.vue?vue&type=script&lang=js"
export * from "./Maintenance.vue?vue&type=script&lang=js"
import style0 from "./Maintenance.vue?vue&type=style&index=0&id=28cbd2b7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28cbd2b7",
  null
  
)

export default component.exports